module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-movie-9c6447d94855c461fda065bbc96c0de5.svg";